import {
  CircleBackground,
  CircleProgress,
  DotsContainer,
  Svg
} from '../styled-components'
import { pinsChildrenSizeOptions, pinsStatusComponentOptions, pinsStatusVariantOptions } from '../constants'

export const ProgressCircle = ({
  percentage,
  iconStatus = pinsStatusVariantOptions.PROGRESS
}) => {
  const radius = 50 // Radius of the progress circle
  const circumference = 2 * Math.PI * radius

  const dotCount = 16 // Number of mini circles
  const dotRadius = 4 // Radius of the mini circles

  const dots = Array.from({ length: dotCount }, (_, index) => {
    const angle = (index / dotCount) * 2 * Math.PI
    const x = 60 + (radius - dotRadius + 4) * Math.cos(angle) // Adjust x position
    const y = 60 + (radius - dotRadius + 4) * Math.sin(angle) // Adjust y position

    return <circle key={index} cx={x} cy={y} r={dotRadius} />
  })

  const IconComponent = pinsStatusComponentOptions[iconStatus]

  return (
    <Svg height={120} width={120}>
      {/* Background circle (transparent) */}
      <CircleBackground cx="60" cy="60" r="50" />

      {/* Filled progress circle */}
      <CircleProgress
        cx="60"
        cy="60"
        r="50"
        circumference={circumference}
        percentage={percentage}
      />
      {IconComponent}
      <DotsContainer>{dots}</DotsContainer>
    </Svg>
  )
}

export const Overdue = () => (
  <g
    transform={`translate(${pinsChildrenSizeOptions.overdue.translate}) scale(${pinsChildrenSizeOptions.overdue.scale})`}
  >
    <svg
      height="120"
      width="120"
      fill="none"
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 7.10327C13.7364 7.10327 14.3333 7.70021 14.3333 8.43656V13.5158C14.3333 14.2522 13.7364 14.8491 13 14.8491C12.2637 14.8491 11.6667 14.2522 11.6667 13.5158V8.43656C11.6667 7.70021 12.2637 7.10327 13 7.10327Z"
        fill="white"
      />
      <mask id="path-3-inside-1_8906_6077" fill="white">
        <path d="M13.0062 15.8491C13.2135 15.8491 13.4084 15.8908 13.5908 15.974C13.7816 16.0489 13.9432 16.1572 14.0759 16.2988C14.2169 16.432 14.3247 16.5943 14.3993 16.7859C14.4823 16.9691 14.5237 17.1647 14.5237 17.3729C14.5237 17.5728 14.4823 17.7643 14.3993 17.9475C14.3247 18.1306 14.2169 18.293 14.0759 18.4346C13.9432 18.5761 13.7816 18.6885 13.5908 18.7718C13.4084 18.8551 13.2135 18.8967 13.0062 18.8967C12.8072 18.8967 12.6123 18.8551 12.4216 18.7718C12.2391 18.6968 12.0774 18.5927 11.9364 18.4595C11.7955 18.318 11.6835 18.1556 11.6006 17.9724C11.5177 17.7809 11.4762 17.5811 11.4762 17.3729C11.4762 17.1647 11.5177 16.9691 11.6006 16.7859C11.6835 16.5943 11.7913 16.432 11.924 16.2988C12.065 16.1572 12.2267 16.0489 12.4091 15.974C12.5998 15.8908 12.7989 15.8491 13.0062 15.8491Z" />
      </mask>
      <path
        d="M13.0062 15.8491C13.2135 15.8491 13.4084 15.8908 13.5908 15.974C13.7816 16.0489 13.9432 16.1572 14.0759 16.2988C14.2169 16.432 14.3247 16.5943 14.3993 16.7859C14.4823 16.9691 14.5237 17.1647 14.5237 17.3729C14.5237 17.5728 14.4823 17.7643 14.3993 17.9475C14.3247 18.1306 14.2169 18.293 14.0759 18.4346C13.9432 18.5761 13.7816 18.6885 13.5908 18.7718C13.4084 18.8551 13.2135 18.8967 13.0062 18.8967C12.8072 18.8967 12.6123 18.8551 12.4216 18.7718C12.2391 18.6968 12.0774 18.5927 11.9364 18.4595C11.7955 18.318 11.6835 18.1556 11.6006 17.9724C11.5177 17.7809 11.4762 17.5811 11.4762 17.3729C11.4762 17.1647 11.5177 16.9691 11.6006 16.7859C11.6835 16.5943 11.7913 16.432 11.924 16.2988C12.065 16.1572 12.2267 16.0489 12.4091 15.974C12.5998 15.8908 12.7989 15.8491 13.0062 15.8491Z"
        fill="white"
        stroke="white"
        strokeWidth="5.33316"
        mask="url(#path-3-inside-1_8906_6077)"
      />
    </svg>
  </g>
)

export const Rejected = () => (
  <g
    transform={`translate(${pinsChildrenSizeOptions.rejected.translate}) scale(${pinsChildrenSizeOptions.rejected.scale})`}
  >
    <svg
      height="120"
      width="120"
      fill="none"
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10533_3127)">
        <path
          d="M11.1364 1.5L2.13637 10.5"
          stroke="white"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d="M2.13637 1.5L11.1364 10.5"
          stroke="white"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_10533_3127">
          <rect
            height="12"
            width="12"
            fill="white"
            transform="translate(0.636368)"
          />
        </clipPath>
      </defs>
    </svg>
  </g>
)

export const Confirm = () => (
  <g
    transform={`translate(${pinsChildrenSizeOptions.completed.translate}) scale(${pinsChildrenSizeOptions.completed.scale})`}
  >
    <svg
      height="120"
      width="120"
      fill="none"
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.95444 6.31255L4.99301 9.40627L10.9544 3.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  </g>
)

export const Closed = () => (
  <g
    transform={`translate(${pinsChildrenSizeOptions.closed.translate}) scale(${pinsChildrenSizeOptions.closed.scale})`}
  >
    <svg
      height="120"
      width="120"
      fill="none"
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM18.6446 9.5292C19.0657 9.95423 19.0625 10.6402 18.6375 11.0613L12.1793 17.4597C11.9746 17.6625 11.6975 17.7754 11.4094 17.7734C11.1213 17.7715 10.8458 17.6548 10.6439 17.4492L7.35211 14.0977C6.93286 13.6708 6.93903 12.9849 7.36589 12.5657C7.79274 12.1465 8.47865 12.1526 8.89789 12.5795L11.4273 15.1548L17.1125 9.52208C17.5376 9.10099 18.2235 9.10417 18.6446 9.5292Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  </g>
)
